import MobileSubcomponentWrapper from './MobileSubcomponentWrapper';

export default MobileSubcomponentWrapper;
